export default {
      id: "android-usage",
      viewBox: "0 0 24 28.845",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#android",
      toString: function () {
        return this.url;
      }
    }